import qs from "qs";
import axios, { AxiosPromise } from "axios";
import { RailsFormErrors, FetchParams, Category } from "../types";
import { axiosHeader } from "../constants";

type Service = {
  fetchAll: (params: FetchParams) => AxiosPromise<Category[]>;
  create: (category: Category) => AxiosPromise<{
    success: boolean;
    instance: Category;
    errors: RailsFormErrors;
  }>;
  update: (category: Category) => AxiosPromise<{
    success: boolean;
    instance: Category;
    errors: RailsFormErrors;
  }>;
  delete: (id: number) => AxiosPromise;
};

export const CategoryService: Service = {
  fetchAll: (params): AxiosPromise<Category[]> =>
    axios.get("/api/ikm/v1/categories/tree", {
      params: {
        page: params.pageNumber,
        per_page: params.pageSize,
        "order[direction][]": params.orderDir || undefined,
        "order[field][]": params.orderBy || undefined,
        query: params.query || undefined,
        resource_type: params.resourceType || undefined,
      },
    }),
  create: (category: Category) =>
    axios({
      url: "/api/ikm/v1/categories",
      method: "post",
      headers: axiosHeader,
      data: transformData(category),
    }),
  update: (category: Category) =>
    axios({
      url: "/api/ikm/v1/categories/" + category.id,
      method: "put",
      headers: axiosHeader,
      data: transformData(category),
    }),
  delete: (id: number) =>
    axios({
      url: "/api/ikm/v1/categories/" + id,
      method: "delete",
    }),
};

const transformData = (category: Category & { resource_type?: string }) =>
  qs.stringify(
    {
      category: {
        name: category.name,
        parent_id: category.parent_id,
        public: category.public,
        ...(category.resource_type && { resource_type: category.resource_type }),
        ...(!category.public && { user_group_ids: category.user_group_ids }),
      },
    },
    { arrayFormat: "brackets" },
  );

export default CategoryService;
